// Search bar open & close
var searchIcon = $("#wz-search-icon")[0];
$(searchIcon).click(function () {
  $(this).parent().parent().toggleClass("wz-search-bar-opened");
  setTimeout(() => {
    var input = $(".wizzy-search-input")[0];
    $(input).focus();
    $(input).click();
  }, 0);
});
window.onWizzyScriptLoaded = function () {
  $("body").on("focus", ".wizzy-search-input", function () {
    $("body").addClass("wz-wrapper-opened");
  });
  $("body").on("blur", ".wizzy-search-input", function () {
    $("body").removeClass("wz-wrapper-opened");
  });

  // Replacing default template
  replaceTemplate("wizzy-search-results-product");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      data.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      window.wizzyConfig.search.configs.general.minQueryLength = 1;
      window.wizzyConfig.common.isLazyInit = true;
      data.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((product) => {
        if (product.sellingPrice) {
          try {
            var offerPrice = parseFloat(product.sellingPrice.replace(/,/g, ""));
          } catch (e) {
            console.log(e);
          }
          var offerPrice_ = offerPrice - (offerPrice * 10) / 100;
          product.offerPrice__ = Math.ceil(
            offerPrice_ - (offerPrice_ * 5) / 100
          );
        }
      });
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      // console.log(data.filters);
      data.filters.inStock = ["true","false"];
      // data.filters.showOOSProductsInOrder = "true";
      data.filters.attributeFacetValuesLimit = 100;
      return data;
    }
  );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      data.minQueryLength = 1;
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      // Check if the <body> element exists
      var bodyElement = document.querySelector('body');
      if (bodyElement) {
          bodyElement.classList.add('wizzy-cache-render');
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      data.attributeFacetValuesLimit = 100;
      console.log(data,"BEFORE_SEARCH_EXECUTED");
      data.minQueryLength = 1;

      const searchCloseButton = window.document.querySelector("#predictive-search-form  button");
      if(searchCloseButton){
        searchCloseButton.click();
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      $(".st-search-bar.custom-desktop").hide();
      return payload;
    }
  );
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};


/////// Mutation Observer

const targetNode = window.document.querySelector(".html-element-padding");

const observerOptions = {
  attributes: true,    // Observe attribute changes
  attributeFilter: ['class'], // Only watch changes to the "class" attribute
};

const mutationCallback = (mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const isWrapperOpened = targetNode.classList.contains('lock');
      
      const headerElement = document.querySelector('.header.color-scheme');
      
      if (headerElement) {
        if (isWrapperOpened) {
          if (!headerElement.classList.contains('is-solid')) {
            headerElement.classList.add('is-solid');
          }
        } else {
          if (headerElement.classList.contains('is-solid')) {
            headerElement.classList.remove('is-solid');
          }
        }
      }
    }
  });
};

const observer = new MutationObserver(mutationCallback);

observer.observe(targetNode, observerOptions);
